 export function disableContextMenu(event) {
   event.preventDefault();
  } 
export function disableShortcuts(e) {
    // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
    if (
        e.keyCode === 123 ||
        (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode ===67 )) || // I and J
        (e.altKey && e.key === 9) || // Alt + Tab
        (e.ctrlKey &&  e.keyCode === 85)|| // U
        (e.ctrlKey && e.keyCode === 74)
      ) {
        e.preventDefault();
        return false;
      }
  }  
  export function disableCopyPaste(event) {
    event.preventDefault();
  } 